import { domAnimation, LazyMotion } from 'framer-motion';
import uniqueId from 'lodash/uniqueId';
import React from 'react';

import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import useOverElement from 'hooks/useOverElement';

import * as A from '../AboutPage.animations';

import * as S from '../AboutPage.styles';

const InfoBoxesSection = ({ numberCards, optionalButton }) => {
  const [ref] = useOverElement();

  return (
    <S.AboutSectionGrid ref={ref}>
      <S.InfoBoxesWrapper>
        {numberCards.map(({ title, subtitle }) => (
          <LazyMotion features={domAnimation} key={uniqueId()}>
            <S.InfoBoxWrapper
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              variants={A.infoBoxesVariants}
            >
              <Text text={title} size="heading3" />
              <S.InfoBoxSubTitle text={subtitle} size="heading3" />
            </S.InfoBoxWrapper>
          </LazyMotion>
        ))}
      </S.InfoBoxesWrapper>

      {optionalButton && (
        <LazyMotion features={domAnimation} key={uniqueId()}>
          <S.InfoBoxButtonWrapper
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={A.infoBoxesVariants}
          >
            <Button label={optionalButton.label} href={optionalButton.href} />
          </S.InfoBoxButtonWrapper>
        </LazyMotion>
      )}
    </S.AboutSectionGrid>
  );
};

export default InfoBoxesSection;
